/**
 * Constants do módulo de Mídia.
 */

// Tabs de filtro de status
export const MEDIA_STATUS_TABS = [
    { value: "all", label: "Todas" },
    { value: "active", label: "Ativas" },
    { value: "inactive", label: "Inativas" },
];

// Labels de status para badges
export const MEDIA_STATUS_LABELS = {
    active: { label: "Ativa", color: "success" },
    inactive: { label: "Inativa", color: "secondary" },
};

// Dimensões recomendadas (TV 43" vertical / portrait)
export const MEDIA_IMAGE_DIMENSIONS = {
    width: 1080,
    height: 1920,
    label: "1080 × 1920px (TV 43\" vertical)",
    aspectRatio: "9:16",
};
